import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useTranslation } from 'react-i18next';
import TreatmentModal from './TreatmentModal';

// Import Images (Update paths to match actual files)
import spaImage from '../assets/Spa/sp.jpeg';
import treatmentImage from '../assets/Home/0814 (1).mp4';

import shirodharaImage1 from '../assets/Spa/Shirodhara-Treatment-Procedure-Benefits.jpeg';
import shirodharaImage2 from '../assets/Spa/WhatsApp Image 2025-08-14 at 15.31.38.jpeg';

import steamBathImage1 from '../assets/Spa/WhatsApp Image 2025-08-14 at 15.19.09.jpeg';

import flowerBathImage1 from '../assets/Spa/WhatsApp Image 2025-08-14 at 21.25.10.jpeg';

import headMassageImage1 from '../assets/Spa/WhatsApp Image 2025-08-14 at 21.26.15.jpeg';
import headMassageImage2 from '../assets/Spa/WhatsApp Image 2025-08-14 at 15.31.38.jpeg';

import faceMassageImage1 from '../assets/Spa/Main_3d15820b-87ba-492b-93fe-42d7038a8a8b.webp';
import faceMassageImage2 from '../assets/Spa/WhatsApp Image 2025-08-14 at 15.31.38.jpeg';

import neckMassageImage1 from '../assets/Spa/5.jpg';
import neckMassageImage2 from '../assets/Spa/WhatsApp Image 2025-08-14 at 15.31.38.jpeg';

import shoulderMassageImage1 from '../assets/Spa/jasmin-package-640x360.jpg';
import shoulderMassageImage2 from '../assets/Spa/WhatsApp Image 2025-08-14 at 15.31.38.jpeg';

import bodyMassageImage1 from '../assets/Spa/massage-desktop-large.jpg';
import bodyMassageImage2 from '../assets/Spa/WhatsApp Image 2025-08-14 at 15.31.38.jpeg';

import backMassageImage1 from '../assets/Spa/WhatsApp Image 2025-08-14 at 21.25.38.jpeg';
import backMassageImage2 from '../assets/Spa/WhatsApp Image 2025-08-14 at 15.31.38.jpeg';

import footMassageImage1 from '../assets/Spa/foot-reflexology-session-header-800x728.avif';
import footMassageImage2 from '../assets/Spa/WhatsApp Image 2025-08-14 at 15.31.38.jpeg';


const AyurvedSpa = () => {
    const { t } = useTranslation();
    const [showModal, setShowModal] = useState(false);
    const [selectedTreatment, setSelectedTreatment] = useState(null);

    const treatments = [
        {
            name: t('spaSection.treatments.shirodhara.name'),
            images: [shirodharaImage1, shirodharaImage2],
            description: t('spaSection.treatments.shirodhara.description'),
            benefits: [
                t('spaSection.treatments.shirodhara.benefits.0'),
                t('spaSection.treatments.shirodhara.benefits.1'),
                t('spaSection.treatments.shirodhara.benefits.2'),
            ],
        },
        {
            name: t('spaSection.treatments.steamBath.name'),
            images: [steamBathImage1],
            description: t('spaSection.treatments.steamBath.description'),
            benefits: [
                t('spaSection.treatments.steamBath.benefits.0'),
                t('spaSection.treatments.steamBath.benefits.1'),
                t('spaSection.treatments.steamBath.benefits.2'),
            ],
        },
        {
            name: t('spaSection.treatments.flowerBath.name'),
            images: [flowerBathImage1],
            description: t('spaSection.treatments.flowerBath.description'),
            benefits: [
                t('spaSection.treatments.flowerBath.benefits.0'),
                t('spaSection.treatments.flowerBath.benefits.1'),
                t('spaSection.treatments.flowerBath.benefits.2'),
            ],
        },
        {
            name: t('spaSection.treatments.headMassage.name'),
            images: [headMassageImage1, headMassageImage2],
            description: t('spaSection.treatments.headMassage.description'),
            benefits: [
                t('spaSection.treatments.headMassage.benefits.0'),
                t('spaSection.treatments.headMassage.benefits.1'),
                t('spaSection.treatments.headMassage.benefits.2'),
            ],
        },
        {
            name: t('spaSection.treatments.faceMassage.name'),
            images: [faceMassageImage1, faceMassageImage2],
            description: t('spaSection.treatments.faceMassage.description'),
            benefits: [
                t('spaSection.treatments.faceMassage.benefits.0'),
                t('spaSection.treatments.faceMassage.benefits.1'),
                t('spaSection.treatments.faceMassage.benefits.2'),
            ],
        },
        {
            name: t('spaSection.treatments.neckMassage.name'),
            images: [neckMassageImage1, neckMassageImage2],
            description: t('spaSection.treatments.neckMassage.description'),
            benefits: [
                t('spaSection.treatments.neckMassage.benefits.0'),
                t('spaSection.treatments.neckMassage.benefits.1'),
                t('spaSection.treatments.neckMassage.benefits.2'),
            ],
        },
        {
            name: t('spaSection.treatments.shoulderMassage.name'),
            images: [shoulderMassageImage1, shoulderMassageImage2],
            description: t('spaSection.treatments.shoulderMassage.description'),
            benefits: [
                t('spaSection.treatments.shoulderMassage.benefits.0'),
                t('spaSection.treatments.shoulderMassage.benefits.1'),
                t('spaSection.treatments.shoulderMassage.benefits.2'),
            ],
        },
        {
            name: t('spaSection.treatments.bodyMassage.name'),
            images: [bodyMassageImage1, bodyMassageImage2],
            description: t('spaSection.treatments.bodyMassage.description'),
            benefits: [
                t('spaSection.treatments.bodyMassage.benefits.0'),
                t('spaSection.treatments.bodyMassage.benefits.1'),
                t('spaSection.treatments.bodyMassage.benefits.2'),
            ],
        },
        {
            name: t('spaSection.treatments.backMassage.name'),
            images: [backMassageImage1, backMassageImage2],
            description: t('spaSection.treatments.backMassage.description'),
            benefits: [
                t('spaSection.treatments.backMassage.benefits.0'),
                t('spaSection.treatments.backMassage.benefits.1'),
                t('spaSection.treatments.backMassage.benefits.2'),
            ],
        },
        {
            name: t('spaSection.treatments.footMassage.name'),
            images: [footMassageImage1, footMassageImage2],
            description: t('spaSection.treatments.footMassage.description'),
            benefits: [
                t('spaSection.treatments.footMassage.benefits.0'),
                t('spaSection.treatments.footMassage.benefits.1'),
                t('spaSection.treatments.footMassage.benefits.2'),
            ],
        },
    ];

    const handleShowModal = (treatment) => {
        setSelectedTreatment(treatment);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedTreatment(null);
    };

    return (
        <>
            {/* Hero Section */}
            <section
                className="relative flex items-center justify-center text-center text-white min-h-[500px] h-[70vh] w-full"
                style={{
                    backgroundImage: `url(${spaImage})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                }}
            >
                <div className="absolute inset-0 bg-black/50"></div>
                <div className="relative z-10 flex flex-col items-center justify-center h-full px-4 sm:px-6 md:px-8 max-w-[1200px] mx-auto">
                    <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 sm:mb-6 text-center">
                        {t('spaSection.title')}
                    </h1>
                    <p className="text-base sm:text-lg md:text-xl max-w-[90%] font-serif text-center">
                        {t('spaSection.description')}
                    </p>
                </div>
            </section>

            <section className="py-8 sm:py-12 md:py-16 ">
                <div className="container mx-auto px-4 sm:px-6 md:px-8">
                    <div className="flex justify-center">
                        <video
                            className="md:w-[600px]     md:h-[800px] sm:w-auto sm:h-[700px] rounded-lg shadow-md object-cover"
                            autoPlay
                            muted
                            loop
                            src={treatmentImage}
                            alt="Ayurveda Treatment Video"
                        />
                    </div>
                </div>
            </section>

            {/* Our Ayurveda Treatments Section */}
            <section className="py-8 sm:py-12 md:py-16">
                <div className="container mx-auto px-4 sm:px-6 md:px-8">
                    <h2 className="text-center mb-6 sm:mb-8 md:mb-12 text-3xl sm:text-4xl md:text-5xl font-bold text-[#114131]">
                        {t('spaSection.treatmentsTitle')}
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 place-items-center">
                        {treatments.map((treatment, index) => (
                            <div key={index} className="flex flex-col w-full sm:max-w-[90%] md:max-w-[80%]">
                                <div className="bg-white rounded-lg shadow-md overflow-hidden flex-grow">
                                    <img
                                        src={treatment.images[0]}
                                        className="w-full h-60 sm:h-64 md:h-72 object-cover"
                                        alt={t(`spaSection.treatments.${treatment.name.toLowerCase().replace(' ', '')}.name`)}
                                        onError={(e) => (e.target.src = '/path/to/placeholder.jpg')}
                                    />
                                    <div className="p-4 sm:p-6 text-center sm:text-center">
                                        <h5 className="text-xl sm:text-2xl font-semibold mb-2">{treatment.name}</h5>
                                        <p className="text-gray-600 mb-4">{treatment.description}</p>
                                        <button
                                            className="bg-[#E6A71A] text-white px-4 py-2 rounded-lg hover:bg-yellow-600 transition-colors mx-auto block"
                                            onClick={() => handleShowModal(treatment)}
                                        >
                                            {t('spaSection.viewMore')}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Treatment Modal */}
            {selectedTreatment && (
                <TreatmentModal
                    show={showModal}
                    handleClose={handleCloseModal}
                    treatment={selectedTreatment}
                />
            )}
        </>
    );
};

export default AyurvedSpa;